import styled from 'styled-components';
import type { UploadedImage } from '@elfsight/configurator-contracts';
import { Icon } from '@elfsight/lib-icon';

type ReopenButtonIconProps = {
  reopenButtonIcon: UploadedImage;
  size: number | [number, number];
};

export function ReopenButtonIcon({
  reopenButtonIcon,
  size
}: ReopenButtonIconProps) {
  if (!reopenButtonIcon?.extension) {
    return <Icon src={reopenButtonIcon.url} size={size} />;
  }

  return <UploadedIcon src={reopenButtonIcon.url} alt="" />;
}

const UploadedIcon = styled.img`
  width: inherit;
  height: inherit;
  object-fit: cover;
`;
